import "dayjs/locale/fa";
import * as React from "react";
import { DatePicker, MobileDatePicker, DateView, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFnsJalali } from "@mui/x-date-pickers/AdapterDateFnsJalali";
import { useMediaQuery, useTheme } from "@mui/material";

interface IMyDatepickerProps {
  onChange?: Function;
  onChangeDate?: Function;
  onChangeJalali?: Function;
  title?: string;
  value?: any;
  disabled?: boolean;
  useDialog?: boolean;
  disablePast?: boolean;
  defaultValue?: string;
  calendarHeight?: number;
  calendarWidth?: number | string;
  view?: DateView;
  openTo?: DateView;
  width?: string
  placeholder?: string
}

const jalaliMonthNames = [
  "\u0641\u0631\u0648\u0631\u062f\u06cc\u0646",
  "\u0627\u0631\u062f\u06cc\u0628\u0647\u0634\u062a",
  "\u062e\u0631\u062f\u0627\u062f",
  "\u062a\u06cc\u0631",
  "\u0645\u0631\u062f\u0627\u062f",
  "\u0634\u0647\u0631\u06cc\u0648\u0631",
  "\u0645\u0647\u0631",
  "\u0622\u0628\u0627\u0646",
  "\u0622\u0630\u0631",
  "\u062f\u06cc",
  "\u0628\u0647\u0645\u0646",
  "\u0627\u0633\u0641\u0646\u062f",
];

const jalaliLocaleText = {
  okButtonLabel: "\u062a\u0627\u06cc\u06cc\u062f",
  cancelButtonLabel: "\u0644\u063a\u0648",
  toolbarTitle: "\u0627\u0646\u062a\u062e\u0627\u0628 \u062a\u0627\u0631\u06cc\u062e",
  monthPickerMonthText: jalaliMonthNames,
};

const jalaliDateFormats = {
  monthShort: "MMMM",
};

const MyDatepicker: React.FunctionComponent<IMyDatepickerProps> = ({
  onChange,
  onChangeDate,
  onChangeJalali,
  value,
  disabled = false,
  useDialog = false,
  disablePast = false,
  calendarHeight = 48,
  calendarWidth = "100%",
  title = "Select date ...",
  view,
  openTo,
  placeholder = "",
  width = "auto"
  
}) => {
  const [currentValue, setCurrentValue] = React.useState<Date | null>(null);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const Picker = useDialog ? MobileDatePicker : DatePicker;

  const handleChangeDate = (date: Date | null) => {
    setCurrentValue(date);
    if (onChange) onChange(date);
    if (onChangeDate) onChangeDate(date);
  };

  React.useEffect(() => {
    if (value !== undefined) {
      setCurrentValue(value ? new Date(value) : null);
    }
  }, [value]);

  const mobileSlotProps = isMobile
    ? {
        popper: {
          sx: {
            "& .MuiPaper-root": {
              width: 260,
              borderRadius: 2,
              p: 0.5,
            },
          },
        },
        layout: {
          sx: {
            "& .MuiDateCalendar-root": {
              width: 280,
              fontSize: "0.85rem",
            },
            "& .MuiPickersDay-root": {
              width: 50,
              height: 30,
              fontSize: "0.8rem",
            },
            "& .MuiPickersCalendarHeader-root": {
              minHeight: 32,
              mb: 0.5,
            },
          },
        },
        actionBar: {
          sx: {
            "& button": {
              fontSize: "0.8rem",
              minWidth: 60,
              px: 1,
            },
            "& .MuiPickersActionBar-root": {
              padding: "4px 8px",
            },
          },
        },
      }
    : {};

  return (
    <>
      <LocalizationProvider
        dateAdapter={AdapterDateFnsJalali as unknown as new (...args: any) => any}
        dateFormats={jalaliDateFormats}
      >
        <Picker
          // label={title}
          value={currentValue}
          format="yyyy/MM/dd"
          disabled={disabled}
          onChange={handleChangeDate}
          disablePast={disablePast}
          localeText={jalaliLocaleText}
          views={["year", "month", "day"]}
          view={view}
          openTo={openTo}
          closeOnSelect={useDialog ? false : undefined}
          slotProps={{
            ...(!useDialog && mobileSlotProps),
            ...(useDialog && {
              actionBar: { actions: ["cancel", "accept"] as ("cancel" | "accept")[] },
            }),
            textField: {
              placeholder,
              variant: "outlined",
              sx: {
                width,
                "& input": {
                  padding: "0 16px",
                  height: 44,
                },
              },
            },
          }}
        />
      </LocalizationProvider>
    </>
  );
};

export default MyDatepicker;
